import { SettingsResponse } from 'types/motus'

export const hasMileMarkerAccess = (response: SettingsResponse): boolean => {
  const firstEntry = response.temporalSettingEntries?.[0]
  return firstEntry?.value?.mileageEntry?.mileMarkerEnabled === true
}

export const getFutureAccessDate = (
  response: SettingsResponse
): string | null => {
  const entries = response.temporalSettingEntries
  if (!entries || entries.length <= 1) return null

  const matchingEntry = entries.find(
    (e) => e.value?.mileageEntry?.mileMarkerEnabled === true
  )

  return matchingEntry?.validStart ?? null
}
